import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=2a4e9982&scoped=true&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=2a4e9982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e9982",
  null
  
)

export default component.exports